/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/CreateDocumentOptions.yaml

import { DocumentStraighteningParameters } from '../core/document_scanner/DocumentEnhancerTypes';
import { ParametricFilter } from '../core/image_processing/ParametricFilters';
import type { DeepPartial } from '../core/utils/utils';

/**
Options for creating a document from images.
*/
export class CreateDocumentOptions {
  /**
    The maximum size of the document image. 0 means no limit.
    
    Default is 0
    */
  public documentImageSizeLimit = 0;
  /**
    The list of filters applied to the page. If not specified, no filters are applied.
    */
  public filters: ParametricFilter[] | null = null;
  /**
    Recognizes documents on created document.
    
    Default is true
    */
  public documentDetection = true;
  /**
    The parameters to use for straightening.
    */
  public straighteningParameters: DocumentStraighteningParameters = new DocumentStraighteningParameters({});

  /** @param source {@displayType `DeepPartial<CreateDocumentOptions>`} */
  public constructor(source: DeepPartial<CreateDocumentOptions> = {}) {
    if (source.documentImageSizeLimit !== undefined) {
      this.documentImageSizeLimit = source.documentImageSizeLimit;
    }
    if (source.filters !== undefined) {
      this.filters =
        source.filters != null
          ? source.filters.map((it: DeepPartial<ParametricFilter>) => {
              return ParametricFilter.from(it);
            })
          : null;
    }
    if (source.documentDetection !== undefined) {
      this.documentDetection = source.documentDetection;
    }
    if (source.straighteningParameters !== undefined) {
      this.straighteningParameters = new DocumentStraighteningParameters(source.straighteningParameters);
    }
  }
}
